import React, { createContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setDynamicMenu } from "../actions/metaDataAction";
import Cookies from "js-cookie";
import Api, { authUser } from "../services/ServiceApi";
import axios from "axios";

export const authUserContext = createContext();

export function AuthContext({ children }) {
  const {
    company_id: CompanyId,
    operator_id: OperatorId,
    project_id: ProjectId,
  } = useParams();
  const systemCode = "MAXI_OPER";
  const dispatch = useDispatch();
  // mockupConfiguration
  const [configurationAuth, setconfigurationAuth] = useState();

  const authValue = {
    ...authUser(),
    CompanyId: CompanyId || Cookies.get("companyid"),
    OperatorId: OperatorId || Cookies.get("operator_id"),
    ProjectId: ProjectId || Cookies.get("project_id"),
    companyData: JSON.parse(
      localStorage.getItem("companyData") === "undefined"
        ? "[]"
        : localStorage.getItem("companyData")
    ),
    operatorData: JSON.parse(
      localStorage.getItem("operator") === "undefined"
        ? "[]"
        : localStorage.getItem("operator")
    ),
    configuration: configurationAuth,
  };
  // fetch data
  useEffect(() => {
    let fetchSuccess = false;
    if (!fetchSuccess) {
      axios
        .all([
          Api.post("get_system_config", {
            company_id: authValue.CompanyId,
            operator_id: authValue.OperatorId,
            project_id: authValue.ProjectId,
            Team_id: authValue.teamId,
            Emp_id: authValue.userId,
            Sys_code: systemCode,
          }),
          Api.post("get_menu_info", {
            company_id: authValue.CompanyId,
            operator_id: authValue.OperatorId,
            project_id: authValue.ProjectId === '' ? null : authValue.ProjectId,
            Sys_code: systemCode,
          }),
        ])
        .then(([responseSystemconfig, responseMenuInfo]) => {
          const { result: resSystemConfig, data: dataSystemConfig } =
            responseSystemconfig?.data;
          const { result: resMenuInfo, data: dataMenuInfo } =
            responseMenuInfo?.data;
          if (resSystemConfig.code === "P") {
            setconfigurationAuth([dataSystemConfig]);
          }
          if (resMenuInfo.code === "P") {
            dispatch(setDynamicMenu(dataMenuInfo.dynamic_menu ?? []));
          }
        });
    }

    return () => {
      fetchSuccess = true;
    };
  }, []);
  return (
    <authUserContext.Provider value={authValue}>
      {children}
    </authUserContext.Provider>
  );
}
